import { MUTATION_CLONE_CAMPAIGN, MUTATION_DELETE_CAMPAIGN, MUTATION_UNSCHEDULE_CAMPAIGN } from '@/modules/campanhas/views/components/graphql'

export const actionButtons = {
  data: () => ({
    loadingButtons: {
      primary: false,
      secondary: false,
    },
    redirectPage: 'sms',
    tooltipIndustryMessage: 'Desabilitado devido a pré-configuração da indústria',
  }),

  computed: {
    anyLoading() {
      return Object.entries(this.loadingButtons).some(([key, value]) => value)
    },

    newCampaign() {
      let path = this.$router.currentRoute.fullPath
      return path.includes('nova') && true
    },

    campaignStatusLowerCase() {
      return this.campaign.status.toLowerCase()
    },

    primaryButton() {
      const button = {
        text: 'Ativar campanha',
        action: this.saveActive,
        isVisible: true,
        isDisabled: Boolean(this.campaign.industry) || (this.anyLoading && !this.loadingButtons.primary),
        tooltip: Boolean(this.campaign.industry),
        tooltipMessage: this.tooltipIndustryMessage,
        isLoading: this.loadingButtons.primary,
      }

      switch (this.campaignStatusLowerCase) {
        case 'active':
        case 'finished':
          button.text = 'Duplicar'
          button.action = this.clone
          break
        case 'scheduled':
          button.text = 'Salvar alterações'
          break
      }

      return button
    },

    secondaryButton() {
      const button = {
        text: 'Salvar alterações',
        action: this.saveDraft,
        isVisible: true,
        isDisabled: Boolean(this.campaign.industry) || (this.anyLoading && !this.loadingButtons.secondary),
        tooltip: Boolean(this.campaign.industry),
        tooltipMessage: this.tooltipIndustryMessage,
        isLoading: this.loadingButtons.secondary,
      }

      switch (this.campaignStatusLowerCase) {
        case 'active':
        case 'finished':
        case 'expired':
        case 'industry_rejected':
          button.isVisible = false
          break
        case 'scheduled':
          button.text = 'Desativar'
          button.action = this.disableDraft
          break
        case 'draft':
          button.text = 'Salvar rascunho'
          break
      }
      return button
    },

    cancelButton() {
      const button = {
        action: this.redirectCampanhas,
        isVisible: true,
        isDisabled: false,
      }

      switch (this.campaignStatusLowerCase) {
        case 'active':
        case 'finished':
        case 'expired':
        case 'industry_rejected':
          button.text = 'Fechar'
          break
        default:
          button.text = 'Cancelar'
      }

      return button
    },

    deleteButton() {
      return {
        text: 'Apagar rascunho',
        action: this.deleteCampaign,
        isVisible: this.campaignStatusLowerCase === 'draft' && !this.newCampaign,
        isDisabled: Boolean(this.campaign.industry) || (this.anyLoading && !this.loadingButtons.deleteButton),
        tooltip: Boolean(this.campaign.industry),
        tooltipMessage: this.tooltipIndustryMessage,
        isLoading: this.loadingButtons.deleteButton,
      }
    },
  },

  methods: {
    async saveActive() {
      this.loadingButtons.primary = true
      try {
        await this.save(false)
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao salvar campanha.' })
      } finally {
        this.loadingButtons.primary = false
      }
    },

    async saveDraft() {
      this.loadingButtons.primary = true
      try {
        await this.save(true)
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao salvar campanha.' })
      } finally {
        this.loadingButtons.primary = false
      }
    },

    async clone() {
      const confirmed = await this.$confirm({
        ...this.$t('campanhas.confirmations.clone'),
        message: `Deseja duplicar ${this.campaign.name ? 'a campanha ' + this.campaign.name.trim().bold() : 'esta campanha'}?`,
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return

      this.loadingButtons.primary = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_CLONE_CAMPAIGN,
          variables: {
            id: this.campaign._id,
          },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
        })
        .then(
          ({
            data: {
              cloneCampaign: { _id: newId },
            },
          }) => {
            this.redirectCampanhas()
          }
        )
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.clone'))
        })
      this.loadingButtons.primary = false
    },

    async disableDraft() {
      const confirmed = await this.$confirm({
        title: 'Desativar campanha',
        message: 'Tem certeza que deseja desativar esta campanha?',
        confirmText: 'Desativar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return

      this.loadingButtons.secondary = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_UNSCHEDULE_CAMPAIGN,
          variables: {
            id: this.campaign._id,
          },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
        })
        .then(() => {
          this.redirectCampanhas()
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
      this.loadingButtons.secondary = false
    },

    async deleteCampaign() {
      const confirmed = await this.$confirm({
        title: 'Remover campanha',
        message: 'Tem certeza que deseja remover esta campanha?',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return

      this.loadingButtons.deleteButton = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_DELETE_CAMPAIGN,
          variables: {
            id: this.campaign._id,
          },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
        })
        .then(() => {
          this.redirectCampanhas()
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
      this.loadingButtons.deleteButton = false
    },

    redirectCampanhas() {
      if (this.campaign.industry) {
        this.$router.push(`/industria/${this.redirectPage}-trade`).catch(() => {})
      } else {
        this.$router.push(`/campanhas/${this.redirectPage}`).catch(() => {})
      }
    },
  },
}
